import Vue from 'vue'
import App from './App'
import axios from 'axios'
import JsonExcel from "vue-json-excel";
import VueHtml2Canvas from 'vue-html2canvas';
import firebase from "firebase/app";
import "firebase/messaging";





Vue.prototype.$http = axios

// BootstrapVue add
import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue'

// Router & Store add
import router from './router'
import store from './store'
// Multi Language Add
import ko from './locales/ko.json'
import en from './locales/en.json'
import VueI18n from 'vue-i18n'
import moment from 'moment';
import numFormat from 'vue-filter-number-format';
import numeral from 'numeral';
import VueCurrencyFilter from 'vue-currency-filter'
import {defaultLocale, localeOptions} from './constants/config'

// Notification Component Add
import Notifications from './components/Common/Notification'
// Breadcrumb Component Add
import Breadcrumb from './components/Common/Breadcrumb'
// RefreshButton Component Add
import RefreshButton from './components/Common/RefreshButton'
// Colxx Component Add
import Colxx from './components/Common/Colxx'
// Perfect Scrollbar Add
import vuePerfectScrollbar from 'vue-perfect-scrollbar'
import contentmenu from 'v-contextmenu'
import VueLineClamp from 'vue-line-clamp'
import VCalendar from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'
import VueScrollTo from 'vue-scrollto'

import VueFileAgent from 'vue-file-agent';    //파일업로드
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css';
import {SlickList, SlickItem} from 'vue-slicksort'
import Vuelidate from 'vuelidate'
import VueDaumPostcode from 'vue-daum-postcode'  //주소검색
import VueMonthlyPicker from 'vue-monthly-picker' // 월별 달력
import VueHtmlToPaper from 'vue-html-to-paper'; //프린

import VueAzureUploader from 'vue-azure-blob-upload';

Vue.use(VueAzureUploader);
Vue.use(Vuelidate);
Vue.use(VueDaumPostcode);
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueI18n)
Vue.use(VueFileAgent);
Vue.filter('numFormat', numFormat(numeral));
Vue.use(VueHtml2Canvas)
Vue.use(VueHtmlToPaper, {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css'
  ]
})

const messages = {ko: ko, en: en};
const locale = (localStorage.getItem('currentLanguage') && localeOptions.filter(x => x.id === localStorage.getItem('currentLanguage')).length > 0) ? localStorage.getItem('currentLanguage') : defaultLocale;
const i18n = new VueI18n({
  locale: locale,
  fallbackLocale: 'en',
  messages
});

Vue.use(Notifications);
Vue.component('piaf-breadcrumb', Breadcrumb);
Vue.component('b-refresh-button', RefreshButton);
Vue.component('b-colxx', Colxx);
Vue.component('vue-perfect-scrollbar', vuePerfectScrollbar);
Vue.component("downloadExcel", JsonExcel);
Vue.component('vue-monthly-picker', VueMonthlyPicker)
Vue.component('vfa-sortable-list', SlickList);
Vue.component('vfa-sortable-item', SlickItem);

Vue.use(require('vue-shortkey'));
Vue.use(contentmenu);
Vue.use(VueLineClamp, {
  importCss: true
})

Vue.use(VueCurrencyFilter,
  {
    symbol: '$',
    thousandsSeparator: '.',
    fractionCount: 2,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: true
  })

const lang = 'ko'
moment.locale(lang)
Vue.use(require('vue-moment'), {moment})

Vue.use(VCalendar, {
  firstDayOfWeek: 2, // ...other defaults,
  formats: {
    title: 'YYYY년 MMM ',
    weekdays: 'WW',
    navMonths: 'MMMM',
    input: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD'],
    dayPopover: 'L'
  },
  datePickerShowDayPopover: false,
  popoverExpanded: true,
  popoverDirection: 'bottom'
});
Vue.use(VueScrollTo);

const firebaseConfig = {
  apiKey: "AIzaSyASK6t5aw3nfzTfZneGzX60raYbDf3srj8",
  authDomain: "hitable-fcm.firebaseapp.com",
  projectId: "hitable-fcm",
  storageBucket: "hitable-fcm.appspot.com",
  messagingSenderId: "172096108359",
  appId: "1:172096108359:web:7cc86ebdff2d04a95a7e62",
  measurementId: "G-SFC1B0YMTE"
};


firebase.initializeApp(firebaseConfig);



// Initialize Firebase Cloud Messaging and get a reference to the service
const messaging = firebase.messaging();
messaging.usePublicVapidKey('BJ-s-IVRFOpgc7lDWrg8Xk4ATqXD3CLbXflCOQD5fauShPLSCaYVyrYys5sk2yk-g0wX0iBhon9k0qYhzq-Htzo')
Vue.prototype.$messaging = messaging;


Vue.config.productionTip = false

export default new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
